export default "__VITE_ASSET__BkDI5P15__"